import { mainnet as viemEthereum } from 'viem/chains';

import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultEnvironments,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

// The only exception to the "Viem chainKey" rule; Viem calls this chain `mainnet`; we use the key `ethereum` instead
export const ethereum = {
  displayName: 'Ethereum',
  runtime: 'evm',
  viemChain: viemEthereum,
  isSupported: true,
  isReleased: true,
  isMainnet: true,
  orderPriority: 1,

  decoration: {
    color: '#8A92B2',
    contrastColor: getContrastColor('#8A92B2'),
  },
  features: {
    wallet: {
      supported: true,
      eip7702: true,
      autoUpgradeSCA: true,
      defaultKind: 'EOA',
      import: true,
    },
    vault: {
      supported: true,
      ccqRecovery: true,
    },
  },
  connectivity: {
    rpc: {
      quicknode: {
        chainKey: 'ethereum-mainnet',
      },
    },
    blockExplorers: {
      primary: {
        base: 'https://etherscan.io',
        token: 'https://etherscan.io/token',
      },
    },
  },
  environments: defaultEnvironments(true),
  swidge: defaultSwidge({
    cowSwap: { chainKey: 'mainnet', blockExplorerKey: '' },
    debridge: {
      chainKey: '1',
      providerContract: '0x43dE2d77BF8027e25dBD179B491e8d64f38398aA',
    },
    lifi: { chainKey: 'ETH' },
    stargate: { chainKey: 'ethereum' },
    across: { chainKey: 'ethereum' },
    xswap: { chainKey: '1' },
    okx: { chainKey: '1' },
    kyberswap: { chainKey: 'ethereum' },
    houdini: { chainKey: '' },
  }),
  services: defaultServices({
    codex: {
      networkId: 1,
      nativeLiquidityAddress: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    },
    defiLlama: { chainKeys: ['ethereum'] },
    trm: { chainKey: 'ethereum' },
    zerion: { chainKey: 'ethereum' },
    coingecko: {
      networkId: 'eth',
      platformId: 'ethereum',
    },
    coingeckoDex: {
      networkId: 'eth',
    },
    qnStreams: {
      networkKey: 'ethereum-mainnet',
    },
    safe: { shortName: 'eth' },
    alchemy: { chainSlug: 'eth-mainnet' },
    pimlico: { chainSlug: 'ethereum' },
  }),
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {
    prod: {
      minUsdWithdrawalAmount: 0.95,
      maxDailyWithdrawals: 10,
      maxDailyMoves: 10,
      minUsdSwidgeFromAmount: 5,
    },
    staging: {
      minUsdWithdrawalAmount: 0.95,
      minUsdSwidgeFromAmount: 5,
    },
  }),
} as const satisfies AllChainConfig<'evm', true>;
